var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "b-modal",
        {
          ref: "modal_catalog",
          attrs: {
            id: "modal-catalog",
            title: _vm.title,
            size: "lg",
            centered: "",
            lazy: "",
            "no-close-on-backdrop": "",
            "no-close-on-esc": "",
            "hide-footer": ""
          },
          on: { hidden: _vm.onHidden }
        },
        [
          _c("b-skeleton-wrapper", {
            attrs: { loading: _vm.isBusy },
            scopedSlots: _vm._u(
              [
                {
                  key: "loading",
                  fn: function() {
                    return [
                      _c(
                        "b-form",
                        [
                          _c(
                            "b-card",
                            { attrs: { "bg-variant": "light" } },
                            [
                              _c(
                                "b-row",
                                { staticClass: "mt-2" },
                                [
                                  _c(
                                    "b-col",
                                    [
                                      _c("b-skeleton", {
                                        staticClass: "mb-2",
                                        attrs: { width: "40%", height: "16%" }
                                      }),
                                      _vm._v(" "),
                                      _c("b-skeleton", {
                                        staticClass: "mb-2",
                                        attrs: {
                                          type: "input",
                                          width: "100%",
                                          height: "30%"
                                        }
                                      }),
                                      _vm._v(" "),
                                      _c("b-skeleton", {
                                        staticClass: "mb-0",
                                        attrs: { width: "85%", height: "15%" }
                                      })
                                    ],
                                    1
                                  )
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _vm._t("optional-skeleton"),
                              _vm._v(" "),
                              _c(
                                "b-row",
                                [
                                  _c(
                                    "b-col",
                                    [
                                      _c("b-skeleton", {
                                        attrs: {
                                          type: "input",
                                          width: "30%",
                                          height: "45%"
                                        }
                                      })
                                    ],
                                    1
                                  )
                                ],
                                1
                              )
                            ],
                            2
                          )
                        ],
                        1
                      )
                    ]
                  },
                  proxy: true
                },
                {
                  key: "default",
                  fn: function() {
                    return [
                      _c(
                        "b-form",
                        {
                          on: {
                            submit: function($event) {
                              $event.preventDefault()
                              return _vm.handleOk.apply(null, arguments)
                            }
                          }
                        },
                        [
                          _c(
                            "b-card",
                            { attrs: { "bg-variant": "light" } },
                            [
                              _c(
                                "b-form-group",
                                {
                                  attrs: {
                                    id: "group-name",
                                    label: _vm.nameLabel,
                                    "invalid-feedback": _vm.nameInvalidFeedback,
                                    state: _vm.nameState,
                                    description: _vm.descriptionLabel
                                  }
                                },
                                [
                                  _c("b-form-input", {
                                    attrs: {
                                      type: "text",
                                      size: "sm",
                                      state: _vm.nameState,
                                      disabled: _vm.isViewMode,
                                      trim: ""
                                    },
                                    model: {
                                      value: _vm.newItem.name,
                                      callback: function($$v) {
                                        _vm.$set(_vm.newItem, "name", $$v)
                                      },
                                      expression: "newItem.name"
                                    }
                                  })
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c(
                                "b-form-group",
                                { attrs: { id: "group-color", label: "Цвет" } },
                                [
                                  _c(
                                    "b-input-group",
                                    {
                                      attrs: { size: "sm" },
                                      scopedSlots: _vm._u([
                                        {
                                          key: "prepend",
                                          fn: function() {
                                            return [
                                              _c("div", {
                                                style: _vm.colorPreviewStyle(
                                                  _vm.newItem.color || "#FFFFFF"
                                                ),
                                                attrs: { id: "color-picker" }
                                              })
                                            ]
                                          },
                                          proxy: true
                                        }
                                      ])
                                    },
                                    [
                                      _vm._v(" "),
                                      _c("b-form-input", {
                                        attrs: {
                                          id: "input-color",
                                          value: _vm.newItem.color,
                                          placeholder: "#RRGGBB"
                                        },
                                        on: {
                                          update: function(value) {
                                            return (_vm.newItem.color = value.toUpperCase())
                                          }
                                        }
                                      })
                                    ],
                                    1
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "b-popover",
                                    {
                                      attrs: {
                                        target: "color-picker",
                                        triggers: "click",
                                        placement: "bottom"
                                      }
                                    },
                                    [
                                      _c("Compact", {
                                        attrs: {
                                          value: _vm.newItem.color || "#FFFFFF"
                                        },
                                        on: {
                                          input: function(newColor) {
                                            return _vm.$set(
                                              _vm.newItem,
                                              "color",
                                              newColor.hex
                                            )
                                          }
                                        }
                                      })
                                    ],
                                    1
                                  )
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _vm._t("optional-fields", null, {
                                model: _vm.newItem,
                                disabled: _vm.isViewMode
                              }),
                              _vm._v(" "),
                              _c(
                                "b-form-checkbox",
                                {
                                  attrs: {
                                    size: "md",
                                    disabled: _vm.isViewMode || _vm.isCreateMode
                                  },
                                  model: {
                                    value: _vm.newItem.active,
                                    callback: function($$v) {
                                      _vm.$set(_vm.newItem, "active", $$v)
                                    },
                                    expression: "newItem.active"
                                  }
                                },
                                [_vm._v("Активен / не активен")]
                              )
                            ],
                            2
                          )
                        ],
                        1
                      )
                    ]
                  },
                  proxy: true
                }
              ],
              null,
              true
            )
          }),
          _vm._v(" "),
          [
            _c(
              "div",
              { staticClass: "w-100 d-flex justify-content-end py-2" },
              [
                _c(
                  "b-button",
                  {
                    staticClass: "mr-2",
                    attrs: { size: "sm", variant: "secondary" },
                    on: { click: _vm.handleCancel }
                  },
                  [
                    _vm._v(
                      "\n          " +
                        _vm._s(_vm.isViewMode ? "Закрыть" : "Отменить") +
                        "\n        "
                    )
                  ]
                ),
                _vm._v(" "),
                !_vm.isViewMode
                  ? _c(
                      "b-button",
                      {
                        attrs: {
                          size: "sm",
                          variant: "success",
                          disabled: _vm.loading
                        },
                        on: { click: _vm.handleOk }
                      },
                      [
                        _vm.loading
                          ? _c("b-spinner", { attrs: { small: "" } })
                          : _vm._e(),
                        _vm._v(" "),
                        _c("font-awesome-icon", {
                          staticClass: "mr-1",
                          attrs: { icon: "save" }
                        }),
                        _vm._v("\n          Сохранить\n        ")
                      ],
                      1
                    )
                  : _vm._e()
              ],
              1
            )
          ]
        ],
        2
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-87d616d8", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-87d616d8","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Catalogs/Catalog.vue
// module id = null
// module chunks = 